/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BlobFileType = {
    ImportUpload: 'ImportUpload'
} as const;
export type BlobFileType = typeof BlobFileType[keyof typeof BlobFileType];


export function instanceOfBlobFileType(value: any): boolean {
    for (const key in BlobFileType) {
        if (Object.prototype.hasOwnProperty.call(BlobFileType, key)) {
            if (BlobFileType[key as keyof typeof BlobFileType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BlobFileTypeFromJSON(json: any): BlobFileType {
    return BlobFileTypeFromJSONTyped(json, false);
}

export function BlobFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlobFileType {
    return json as BlobFileType;
}

export function BlobFileTypeToJSON(value?: BlobFileType | null): any {
    return value as any;
}

export function BlobFileTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BlobFileType {
    return value as BlobFileType;
}

